export default __webpack_public_path__ + "static/media/DisableAddIcon.f3c73efa.svg";